import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import { getRouterBasename } from "./constants/routerBasename";
import "./App.css";

function Main() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const isCmsPage =
    pathname === "/privacy_policy" || pathname === "/support";

  return (
    <main
      className={`main ${isHome ? "main--home" : ""} ${
        isCmsPage ? "main--cms" : ""
      }`}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route
          path="/privacy-policy"
          element={<Navigate to="/privacy_policy" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
}

export default function App() {
  const basename = getRouterBasename() || undefined;

  return (
    <BrowserRouter basename={basename}>
      <div className="app">
        <Navbar />
        <Main />
        <footer className="footer">
          <p>© {new Date().getFullYear()} ChillnPark</p>
        </footer>
      </div>
    </BrowserRouter>
  );
}
